module.exports = __webpack_public_path__ + "media/images/flags/64/Anguilla-6f4d73b8339dd1c5ea7c65a9d020cca3.png";